import * as service from './service'
export default {
  namespace: 'EleCarQuestionnaire',
  state: {
    surveyAnswerData: {}
  },
  effects: {
    * surveyAnswer ({ payload }, { call, put }) {
      const res = yield call(service.surveyAnswer, payload)
      yield put({
        type: 'save',
        payload: {
          surveyAnswerData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
